import Cache from 'root/cache';
import Modals from 'root/modals';
import SVG from 'root/module/svg_icon';
import View from 'view/base';

export default View.extend({
    email: '',
    password: '',
    from_openid: false,

    events: {
        'click .workspace-create': 'onCreateWorkspace',
        'click .profile-delete'  : 'onDeleteProfile'
    },

    dom_handlers: {
        onCreateWorkspace: function(e) {
            if (this.from_openid === true) {
                this.trigger('create');
            } else {
                Cache.app.request({
                    action: 'app/register',
                    data: {
                        email    : this.email,
                        password : this.password,
                        user_id  : this.user_id
                    },
                    anon: true,
                    success: () => {
                        this.trigger('success');
                    }
                });
            }
        },

        onDeleteProfile: function(e) {
            if (this.from_openid === true) {
                this.trigger('delete');
            } else {
                Modals.deleteMyProfile(this.email, this.password, this.user_id);
            }
        }
    },

    initialize: function(options) {
        this.email    = options.email;
        this.password = options.password;
        this.user_id  = options.user_id;
        this.from_openid = options.from_openid ? true : false;
    },

    render: function() {
        // logged in, but has no workspace access (empty profile)
        var content =
        '<div class="logo"><a href="https://www.userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
        '<h3>You don\'t have access to any workspaces</h3>' +
        '<div class="divider-24"></div>' +
        '<div class="workspace-create flex-between box-neutral cursor-pointer">' +
            '<span><i class="fa-regular fa-plus margin-right-4"></i>Create a workspace</span>' +
            '<span class="text-primary text-small font-weight-medium">14 day free trial</span>' +
        '</div>' +
        '<div class="hr"><span class="text-info">or</span></div>' +
        '<div class="text-align-center">' +
            '<button type="button" class="profile-delete small secondary">Delete my profile</button>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});
